import type { CrremSettings } from "features/energy-analysis-dashboard/model/types";

import { Popover } from "@mui/material";
import { Button } from "components/ButtonNew";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type {
  CrremPathwayCorrectionOption,
  CrremPathwayPartitionBy,
  CrremPathwayScale,
  CrremPathwayViewSettings,
} from "../model/types";

import { CrremPathwaySettingsForm } from "./CrremPathwaySettingsForm";

type CrremPathwaySettingsMenuProps = {
  correctionOptions: CrremPathwayCorrectionOption[];
  disabled?: boolean;
  onSave: (settings: CrremSettings) => void;
  onViewChange: (change: Partial<CrremPathwayViewSettings>) => void;
  partitionBy: CrremPathwayPartitionBy;
  scale: CrremPathwayScale;
  settings: CrremSettings;
  visibleCorrectionIds: string[];
};

export const CrremPathwaySettingsMenu = ({
  correctionOptions,
  disabled,
  onSave,
  onViewChange,
  partitionBy,
  scale,
  settings,
  visibleCorrectionIds,
}: CrremPathwaySettingsMenuProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  return (
    <>
      <Button
        className="w-full"
        disabled={disabled}
        height="4rem"
        isActive={Boolean(anchorEl)}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        size="md"
        startIconName="Gears"
        variant="secondary"
      >
        {t("BuildingProfile.energyAnalysis.settings.title")}
      </Button>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        PaperProps={{ className: "min-w-[36rem] p-6" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <CrremPathwaySettingsForm
          correctionOptions={correctionOptions}
          disabled={disabled}
          onPartitionByChange={(value) => onViewChange({ partitionBy: value })}
          onScaleChange={(value) => onViewChange({ scale: value })}
          onSettingsChange={(key, value) => {
            onSave({ ...settings, [key]: value });
          }}
          onVisibleCorrectionIdsChange={(ids) => onViewChange({ visibleCorrectionIds: ids })}
          partitionBy={partitionBy}
          scale={scale}
          settings={settings}
          visibleCorrectionIds={visibleCorrectionIds}
        />
      </Popover>
    </>
  );
};
